import enviro from 'enviro';
const isQAProxy = window.location.hostname.indexOf('wthubspot') >= 0;
const isProd = enviro.isProd() && !isQAProxy;
const MONTHLY_NO_DISCOUNT_PROD = 52;
const ACMP_NO_DISCOUNT_PROD = 86;
const ANNUAL_10_DISCOUNT_PROD = 72;
const MONTHLY_NO_DISCOUNT_QA = 102;
const ACMP_NO_DISCOUNT_QA = 110;
const ANNUAL_10_DISCOUNT_QA = 137;
export const MONTHLY_NO_DISCOUNT = isProd ? MONTHLY_NO_DISCOUNT_PROD : MONTHLY_NO_DISCOUNT_QA;
export const ANNUAL_10_DISCOUNT = isProd ? ANNUAL_10_DISCOUNT_PROD : ANNUAL_10_DISCOUNT_QA;
export const ACMP_NO_DISCOUNT = isProd ? ACMP_NO_DISCOUNT_PROD : ACMP_NO_DISCOUNT_QA;